// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"abc8ab1e","893":"efdedf9d","976":"27df4535"}[chunkId] + ".chunk.js";
};